export const HomeVideo = require('assets/video/rcms-video.mp4')
